import React, { Component, useEffect, useState } from "react";
import { Route } from "react-router-dom";
import LeftSidebar from "./LeftSidebar";
import TopHeader from "./TopHeader";
import Footer from "./Footer";
import "../../assets/scss/app.scss";
import { scAxiosAdmin } from "../..";
import { API_TOKEN_NAME } from "../../constants";
import { toast, ToastContainer } from "react-toastify";
import EmailConfigComponent from "./EmailConfigComponent";

const EmailConfiguration = ({ user }) => {
  const [adminEmail, setAdminEmail] = useState("");
  const [saveAdminLoading, setSaveAdminLoading] = useState(false);
  const [error, setError] = useState(null);
  const [postResponseAdminRole, setPostResponseAdminEmail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState({});
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await scAxiosAdmin.request("/settings/12", {
          method: "get",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
          params: {
            // ...data
          },
        });
        setResponseData(response.data);
        setAdminEmail(response.data.value);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const handleTextChange = (event) => {
    setAdminEmail(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSaveAdminLoading(true);
    setError(null);
    const requestData = {
      value: adminEmail,
    };
    // console.log("some data", checkedIds, roleName)
    try {
      const response = await scAxiosAdmin.post(
        "/settings_update/11",
        requestData,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": `application/json`,
            Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
          },
        }
      );
      setPostResponseAdminEmail(response.data);
      setSaveAdminLoading(false);
      toast.success("Admin Emails Updated Successfully!");
    } catch (err) {
      setError(err);
      setSaveAdminLoading(false);
    }
  };
  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="row g-5">
              <div className="col-12 col-md-4">
                <EmailConfigComponent
                  title={"Appointment Email"}
                  label={"Put Appointment Administrator Email Here"}
                  query={12}
                  formHelp="use come (,) to separate emails"
                ></EmailConfigComponent>
              </div>
              <div className="col-12 col-md-4">
                <EmailConfigComponent
                  title={"Emergency Email"}
                  label={"Put Emergency Administrator Email Here"}
                  query={13}
                  formHelp="use come (,) to separate emails"
                ></EmailConfigComponent>
              </div>
              <div className="col-12 col-md-4">
                <EmailConfigComponent
                  title={"Inquiry Email"}
                  label={"Put Inquiry Administrator Email Here"}
                  query={14}
                  formHelp="use come (,) to separate emails"
                ></EmailConfigComponent>
              </div>
              <div className="col-12 col-md-4">
                <EmailConfigComponent
                  title={"Corporate Inquiry Email"}
                  label={"Put Corporate Inquiry Administrator Email Here"}
                  query={15}
                  formHelp="use come (,) to separate emails"
                ></EmailConfigComponent>
              </div>
              <div className="col-12 col-md-4">
                <EmailConfigComponent
                  title={"Brith/Death Cirtificate Email"}
                  label={"Put Brith/Death Cirtificate Administrator Email Here"}
                  query={16}
                  formHelp="use come (,) to separate emails"
                ></EmailConfigComponent>
              </div>
              <div className="col-12 col-md-4">
                <EmailConfigComponent
                  title={"Home Sample Collection Email"}
                  label={"Home sample collection Administrator Email Here"}
                  query={17}
                  formHelp="use come (,) to separate emails"
                ></EmailConfigComponent>
              </div>
              <div className="col-12 col-md-4">
                <EmailConfigComponent
                  title={"Contact Us Email"}
                  label={"Contact Us Administrator Email Here"}
                  query={18}
                  formHelp="use come (,) to separate emails"
                ></EmailConfigComponent>
              </div>
            </div>
          </div>
          <Route component={Footer} />
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default EmailConfiguration;



// WEBPACK FOOTER //
// ./src/component/admin/EmailConfiguration.js